<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
/*
 * 셸 레이아웃은 styles/shell.css 가, 디자인 토큰은 styles/tokens.css 가 담당한다.
 * 여기에는 전역 리셋과 Element Plus 보정만 남긴다.
 *
 * (예전에는 App.vue 가 Navigation 을 직접 렌더하고 route.path !== '/login' 으로
 *  표시 여부를 판단했다. 지금은 라우터의 중첩 레이아웃이 그 역할을 한다.)
 */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: var(--font-sans);
  font-size: var(--fs-md);
  line-height: 1.5;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: var(--color-bg);
  color: var(--color-text);
  overflow-x: hidden;
}

#app {
  min-height: 100vh;
  overflow-x: hidden;
  width: 100%;
}

.container {
  max-width: var(--shell-max-w);
  margin: 0 auto;
  padding: 0 var(--shell-gutter);
}

/* 프로필 이미지 원형 중앙 정렬 */
.el-avatar img {
  object-fit: cover;
  object-position: center;
  width: 100%;
  height: 100%;
}

/*
 * 아바타에 2px 테두리를 두르면 22px 짜리 목록용 아바타가 사실상 18px 이 된다.
 * 겹쳐 쌓는 서포터 스택에서는 테두리끼리 붙어 원이 뭉개진다.
 * 배경 위에서 원을 분리해 주는 최소한(1px, 6% 알파)만 남긴다.
 */
.el-avatar {
  border: 1px solid var(--color-ink-wash);
  background: var(--color-surface-2);
  color: var(--color-text-muted);
  font-weight: var(--fw-semibold);
}

@media (max-width: 767px) { /* --bp-mobile-max */
  .container {
    padding: 0 var(--shell-gutter-mobile);
  }
}
</style>
